const initialState = {
  total: null,
}
const GET_TOTAL = 'GET_TOTAL'
const orderReducer = (state = initialState, action) => state

export const getTotal = total => ({ type: 'GET_TOTAL', payload: total })

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TOTAL:
      return { total: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/order.js